import React, { PropsWithChildren, useEffect } from 'react';
import { speedbumpModal, useModal } from '../../providers/Modal/Modal';

export interface ISpeedbumpDataEvent {
    event: 'Speedbump';
    width?: number;
    target?: '_blank' | '_self';
    externalUrl?: string;
    title?: string;
    content?: string;
}

export interface IWrapperRedirect {
    event: 'WrapperRedirect';
    url?: string | URL;
    target?: string;
    features?: string;
}

export function isMessageEventType(data: unknown, event: string): boolean {
    return (
        typeof data === 'object' &&
        data !== null &&
        'event' in data &&
        data.event === event
    );
}

export const MessageWrapper = (props: PropsWithChildren<unknown>): JSX.Element => {
    const { setModalContent, toggleModal, setModalClass } = useModal();

    useEffect(() => {
        const messageListener = (event: MessageEvent<unknown>): void => {
            if (isMessageEventType(event.data, 'Speedbump')) {
                const { width, target, externalUrl, title, content } = event.data as ISpeedbumpDataEvent;
                setModalClass('Speedbump');
                setModalContent(speedbumpModal(toggleModal, width, target, externalUrl, title, content));
                toggleModal();
            } else if (isMessageEventType(event.data, 'WrapperRedirect')) {
                const { url, target, features } = event.data as IWrapperRedirect;
                window.open(url, target, features);
            }
        };
        window.addEventListener('message', messageListener);
        return (): void => window.removeEventListener('message', messageListener);
    }, []);

    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
};